export const version = "abstract-signer/5.4.0";
